import { getCommunityPins } from './communities';
import { getVideo, calculateTastemakerScore } from './metadata';

export interface CommunityFeedItem {
  communityId: string;
  videoHash: string;
  video: any;
  pinnedBy: string;
  pinnedAt: number;
}

export function getCommunityFreshFeed(communityId: string): CommunityFeedItem[] {
  const pins = getCommunityPins(communityId);
  
  return pins
    .map(pin => ({
      communityId,
      videoHash: pin.videoHash,
      video: getVideo(pin.videoHash),
      pinnedBy: pin.pinnedBy,
      pinnedAt: pin.pinnedAt
    }))
    .filter(item => item.video)
    .sort((a, b) => b.pinnedAt - a.pinnedAt)
    .slice(0, 50);
}

export function getCommunityPopularFeed(communityId: string): CommunityFeedItem[] {
  const pins = getCommunityPins(communityId);
  const grouped = new Map<string, any[]>();
  
  pins.forEach(pin => {
    if (!grouped.has(pin.videoHash)) {
      grouped.set(pin.videoHash, []);
    }
    grouped.get(pin.videoHash)!.push(pin);
  });

  return Array.from(grouped.entries())
    .map(([videoHash, videoPins]) => ({
      communityId,
      videoHash,
      video: getVideo(videoHash),
      pinnedBy: videoPins[0].pinnedBy,
      pinnedAt: videoPins[0].pinnedAt,
      pinCount: videoPins.length
    }))
    .filter(item => item.video)
    .sort((a, b) => (b as any).pinCount - (a as any).pinCount)
    .slice(0, 50);
}

export function getCommunityRisingFeed(communityId: string): CommunityFeedItem[] {
  const pins = getCommunityPins(communityId);
  const now = Date.now();
  const last24h = now - (24 * 60 * 60 * 1000);
  
  const grouped = new Map<string, any[]>();
  
  pins.forEach(pin => {
    if (!grouped.has(pin.videoHash)) {
      grouped.set(pin.videoHash, []);
    }
    grouped.get(pin.videoHash)!.push(pin);
  });

  return Array.from(grouped.entries())
    .map(([videoHash, videoPins]) => {
      const recentPins = videoPins.filter(p => p.pinnedAt > last24h);
      
      let tastemakerWeight = 0;
      recentPins.forEach(pin => {
        const score = calculateTastemakerScore(pin.pinnedBy);
        tastemakerWeight += Math.log10(Math.max(score, 1)) * 10;
      });
      
      return {
        communityId,
        videoHash,
        video: getVideo(videoHash),
        pinnedBy: videoPins[0].pinnedBy,
        pinnedAt: videoPins[0].pinnedAt,
        momentum: recentPins.length,
        tastemakerMomentum: tastemakerWeight
      };
    })
    .filter(item => item.video && (item as any).momentum > 0)
    .sort((a, b) => (b as any).tastemakerMomentum - (a as any).tastemakerMomentum)
    .slice(0, 50);
}
